module.exports = __webpack_public_path__ + "static/media/loc7_img9.16b2387e.jpg";